<template>
    <span class="guest-name">
        <template v-if="nameMissing">
            <span v-bind:class="{'text-error' : highlightIfMissing, 'text-temporary' : !highlightIfMissing}">Not supplied</span>
        </template>
        <template v-else>
            {{guest.lastName}}
        </template>
    </span>
</template>

<script>

    export default {
        name: 'GuestName',
        props: {
            guest: Object,
            highlightIfMissing: Boolean
        },
        computed: {
            nameMissing: function() {
                if (!this.guest || !this.guest.lastName) {
                    return true;
                }
                return false;
            }
        },
        mounted() {
        }
    }

</script>